import React from "react";

const PopUpList = ({ items }) => {
  return (
    <div className="pop-up-list">
      <ul>
        {items &&
          items.map((item, i) => (
            <li key={i}>
              <p className="title">{item.title}</p>
              <b>{item.value}</b>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default PopUpList;
